module.exports = __webpack_public_path__ + "static/media/Paloma Ave, Burlingame, CA3.6f6f50a2.jpg";